<template>
  <div>
    <ContentWrapperControl class="mt-4">
      <div class="bg-white p-4 rounded shadow">
        <div class="mb-3">
          <TextControl
            @typing="typing"
            v-bind:value="date_of_birth"
            name="date_of_birth"
            type="date_of_birth"
          />
        </div>
        <div>
          <ButtonControl
            v-if="!has_date_of_birth"
            v-on:click="update"
            v-bind:disabled="disabled"
          >
            {{ lang("lbl_0000294") }}
          </ButtonControl>
          <span v-else class="mt-1 text-xs text-grey-dark italic">{{
            lang("lbl_0000259")
          }}</span>
        </div>
      </div>
      <PrivacyInfoControl />
    </ContentWrapperControl>
  </div>
</template>

<script>
import ButtonControl from "./../../components/controls/ButtonControl.vue";
import ContentWrapperControl from "./../../components/controls/ContentWrapperControl.vue";
import TextControl from "./../../components/controls/TextControl.vue";
import PrivacyInfoControl from "@/components/controls/PrivacyInfoControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";

export default {
  mixins: [mixin],
  components: {
    ButtonControl,
    ContentWrapperControl,
    TextControl,
    PrivacyInfoControl,
  },
  data() {
    return {
      theme: "error",
      display: false,
      message: "",
      changed: false,
      disabled: true,
      date_of_birth: "",
      has_date_of_birth: this.$store.state.info.date_of_birth != null,
    };
  },
  mounted() {
    this.$emit("checkauth");
    this.$emit("nofooter", true);
    this.$emit("shownavbar", {
      title: this.lang("lbl_0000275"),
      show: true,
      back: true,
    });

    let state = this.$store.state;
    this.date_of_birth = this.formatToISODate(state.enroll.date_of_birth) ?? null;

    // this.date_of_birth =
    //   this.formatToISODate(this.$store.state.info.date_of_birth) ?? null;

    if (this.$store.state.info.date_of_birth) {
      this.$router.push("/dashboard");
    }
  },
  methods: {
    typing(n) {
      let state = this.$store.state;
      this.date_of_birth = n.value;
      this.disabled =
        this.date_of_birth === "" ||
        this.date_of_birth ===
          this.formatToISODate(this.$store.state.info.date_of_birth);
      state.enroll.date_of_birth = this.date_of_birth;
    },
    update() {

      this.$emit("showloader");
      let state = this.$store.state;
      const [year, month, day] = this.date_of_birth.split("-");
      const formatted_date = `${month}/${day}/${year}`;

      User.updateDateOfBirth(this.$store.state.key, month, day, year)
        .then(() => {
          state.info.date_of_birth = formatted_date;
          state.enroll.date_of_birth = null;
          this.disabled = true;
          this.changed = false;
          this.$emit("hideloader");
          this.$emit("success", this.lang("lbl_0000261"));

          if(!state.info.tin){
            this.$router.push("/user/info/checklist/optional");
            return;
          }
          this.$router.push("/");
        })
        .catch((error) => {
          this.$emit("error", error);
        });
    },
    closed() {
      this.display = false;
    },
    formatToISODate(date) {
      if (!date) return "";
      const parsed_date = new Date(date);
      if (isNaN(parsed_date)) return "";
      const year = parsed_date.getFullYear();
      const month = String(parsed_date.getMonth() + 1).padStart(2, "0");
      const day = String(parsed_date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
  },
  watch: {
    date_of_birth(val) {
      this.changed = val != this.$store.state.info.date_of_birth;
    },
  },
};
</script>
